import React from 'react';
export function AustriaFlag({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 900 600" className={className} xmlns="http://www.w3.org/2000/svg" data-id="element-50">
      <rect width="900" height="600" fill="#ED2939" rx="30" data-id="element-51" />
      <rect y="200" width="900" height="200" fill="#FFFFFF" data-id="element-52" />
    </svg>;
}
export function GermanyFlag({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 900 600" className={className} xmlns="http://www.w3.org/2000/svg" data-id="element-53">
      <rect width="900" height="600" fill="#FFCE00" rx="30" data-id="element-54" />
      <rect width="900" height="200" fill="#000000" rx="30" data-id="element-55" />
      <rect y="200" width="900" height="200" fill="#DD0000" data-id="element-56" />
    </svg>;
}
export function FranceFlag({
  className = ''
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 900 600" className={className} xmlns="http://www.w3.org/2000/svg" data-id="element-57">
      <rect width="900" height="600" fill="#FFFFFF" rx="30" data-id="element-58" />
      <rect width="300" height="600" fill="#002395" rx="30" data-id="element-59" />
      <rect x="600" width="300" height="600" fill="#ED2939" rx="30" data-id="element-60" />
    </svg>;
}